/**
 * Notification presentation helpers for the Home activity feed: where a row
 * links to, and how its kind / action CTA are labelled.
 */

/** Short kind chip under the title on Home activity. */
export function notificationKindLabel(type: string): string {
	switch (type) {
		case "action_approval_needed":
			return "Needs approval";
		case "connection_permission_request":
			return "Authorization needed";
		case "browser_auth_expired":
			return "Sign-in required";
		case "invitation_received":
			return "Invitation";
		case "agent_message":
			return "Agent";
		default:
			return "Notification";
	}
}

/**
 * Explicit CTA when the user has something to *do*.
 * Returns null when row click is enough (digests) or when we lack a real target.
 */
export function notificationActionLabel(
	type: string,
	href?: string | null,
): string | null {
	// No destination → no lying CTA
	if (href == null || href === "") return null;

	switch (type) {
		case "action_approval_needed":
			return "Review & approve";
		case "connection_permission_request":
			return "Authorize connection";
		case "browser_auth_expired":
			return "Open connection";
		case "invitation_received":
			return "Accept invitation";
		default:
			return null;
	}
}
